import _ from 'lodash'
import request from '@ps/utils/request'
import { ResponseData } from 'request'
import { ResourcePoolItem } from '@ps/bridge/resource/pool/type'

// 接口文档：http://localhost:8067/?doc=playsmart/playturbo%2fhandler%2fplaysmart%2feditor_file.go

export function fileSave(data: {
  projectKey: number
  path: string
  enc?: string // 编码类型：base64或binary，默认为binary
  binContent: string
}) {
  return request({
    url: '/ps/editor/file/save',
    method: 'post',
    headers: { 'Content-Type': 'text/plain' },
    params: {
      pid: data.projectKey,
      path: data.path,
      enc: data.enc || 'binary',
    },
    data: data.binContent,
  })
}

/**
 * 保存多个文件
 * @param data
 */
export function saveMultiFiles(data: {
  pid: number
  files: { path: string; data: string }[]
}) {
  return request<ResponseData<{ path: string; data: string }[]>>({
    url: '/ps/editor/file/msave',
    method: 'post',
    params: {
      pid: data.pid,
    },
    data: {
      files: JSON.stringify(data.files),
    },
  })
}

export function getFiles(params: { pid: number }) {
  return request({
    url: '/ps/editor/file/list',
    method: 'get',
    params,
  })
}

export function moveFile(params: {
  pid: number
  src: string
  dst: string
  overwrite?: number
}) {
  return request({
    url: '/ps/editor/file/move',
    method: 'post',
    params,
  })
}

/**
 * 批量复制文件
 */
export function batchCopyFile(params: {
  pid: number
  batch: { src: string; dst: string }[]
  overwrite?: number
}) {
  return request<ResponseData<{ src: string; dst: string }[]>>({
    url: '/ps/editor/file/copy',
    method: 'post',
    params: _.pick(params, ['pid', 'overwrite']),
    data: {
      batch: JSON.stringify(params.batch),
    },
  })
}

export function copyFile(params: {
  pid: number
  src: string
  dst: string
  overwrite?: number
}) {
  return request({
    url: '/ps/editor/file/copy',
    method: 'post',
    params,
  })
}

export function readFile(params: {
  pid: number
  path: string
  base64?: number
}) {
  return request({
    url: '/ps/editor/file/read',
    method: 'get',
    params,
  })
}

export function saveFile(
  params: {
    pid: number
    path: string
    enc?: string // 编码类型：base64或binary，默认为binary
  },
  data: string,
) {
  return request({
    url: '/ps/editor/file/save',
    method: 'post',
    params: params,
    headers: { 'Content-Type': 'text/plain' },
    data: data,
  })
}

export function updateVar({
  params,
  data,
}: {
  params: {
    pid: number
    name: string
  }
  data: string
}) {
  return request({
    url: '/ps/editor/file/update-var',
    method: 'post',
    params,
    data: {
      data,
    },
  })
}

export function deleteFile(params: {
  pid: number
  path: string
  recursive: number // 是否递归删除整个目录，1或0，默认为0
}) {
  return request({
    url: '/ps/editor/file/delete',
    method: 'post',
    params,
  })
}

export function uploadFileWithProgress(data: {
  targetUrl: string
  fileObj: Blob
  success: () => void
  uploadProgressHandler: () => void
}) {
  try {
    const xhr = new XMLHttpRequest()
    xhr.open('post', data.targetUrl, true)
    xhr.setRequestHeader('Content-Type', 'text/plain')
    const auth = document.cookie
      .split(';')
      .map((c) => c.trim())
      .map((c) => c.split('='))
      .filter((c) => c[0] === 'mws_auth')[0][1]
    xhr.setRequestHeader('auth-token', auth)
    xhr.withCredentials = true
    const reader = new FileReader()
    reader.readAsArrayBuffer(data.fileObj)
    reader.onload = function () {
      const chunck = this.result
      xhr.send(chunck)
    }
    xhr.onload = () => {
      if (data.success) data.success()
    }
    xhr.upload.addEventListener('progress', data.uploadProgressHandler)
  } catch (error) {
    console.log(error)
  }
}

export function getResourcePool(params: { pid: number }): Promise<{
  code: number
  data: { list: Array<ResourcePoolItem> }
  msg: string
}> {
  return request({
    url: '/ps/editor/file/pool',
    method: 'get',
    params,
  })
}

export function resourcePoolDownload(params: {
  pid: number
  name: string
  path: string
  type: string
}): Promise<{
  code: number
  data: { list: Array<ResourcePoolItem> }
  msg: string
}> {
  return request({
    url: '/ps/editor/file/download',
    method: 'get',
    params,
  })
}
